import { Component, Input } from '@angular/core';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-approve-reject-dialog',
  standalone: true,
  imports: [CommonModule,FormsModule],
  templateUrl: './approve-reject-dialog.component.html',
  styleUrl: './approve-reject-dialog.component.scss'
})
export class ApproveRejectDialogComponent {
  isDisabled: boolean = false;
  @Input() showReInitiat: boolean = true;
  @Input() showReject: boolean = true;
  @Input() showApprove: boolean = true;
  @Input() PostiveButton: string = 'Approve';
  @Input() Header: string = 'Approval';
  
  @Input() Detail = {
    ID: 0,
    Remark: null,
    Flag: null as any,
  }

  constructor(
    private toast: ToastService,
    private activeModal: NgbActiveModal,
  ) {}

  ngOnInit(): void {}

  Save(Flag: string) {
    if ((Flag == 'Reject' || Flag == 'Reinitiate') && (this.Detail.Remark == null || this.Detail.Remark == '')) {
      this.toast.show({message:'Please enter remark..',type:toastTypeEnum.warning});
    } else {
      if (!this.showReInitiat && Flag == 'Reinitiate') {
        this.toast.show({message:'Reinitiate not allow..',type:toastTypeEnum.warning});
      } else {
        this.Detail.Flag = Flag;
        this.activeModal.close(this.Detail);
      }
    }
  }
  
  close() {
    this.activeModal.close();
  }
}
